import { useEffect, useState } from 'react'
import * as React from 'react'
import Lottie from 'components/utils/Lottie'

// Cache for loaded animation data
let sparklesCache: object | null = null

interface Props {
  style?: React.CSSProperties
}

/**
 * Lazy-loaded sparkles Lottie animation.
 * Animation data is loaded on-demand and cached for subsequent renders.
 */
function SparklesAnimation({ style }: Props) {
  const [animationData, setAnimationData] = useState<object | null>(sparklesCache)

  useEffect(() => {
    if (animationData) return

    const loadAnimation = async() => {
      try {
        const module = await import('../Animations/sparkles.json')
        sparklesCache = module.default
        setAnimationData(module.default)
      } catch(error) {
        console.error('Failed to load sparkles animation', error)
      }
    }

    loadAnimation()
  }, [animationData])

  if (!animationData) return null

  return (
    <Lottie
      animationData={animationData}
      loop
      style={style}
    />
  )
}

export default React.memo(SparklesAnimation)
